// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-search-AddressInput-module__btnInputClear {
    display: none;
    padding: 0 5px;
    color: grey;
    scale: 0.7;
}

.src-sidebar-search-AddressInput-module__btnCurrentLocation {
    padding: 0 7px 0 5px;
    color: grey;
    width: 32px;
}

.src-sidebar-search-AddressInput-module__btnCurrentLocation > svg {
    height: 100%;
    width: 100%;
}

.src-sidebar-search-AddressInput-module__btnClose {
    display: none;
}

.src-sidebar-search-AddressInput-module__inputContainer {
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-gap: 0;

    box-sizing: border-box;
    border: 1px solid #5b616a;
    border-radius: 0.2rem;
    /* for the radius we need some padding otherwise the corners will be nearly hidden */
    padding: 1px;
}

.src-sidebar-search-AddressInput-module__input {
    border: none;
    padding: 0.25rem 0.5rem;
    font-size: 1.05rem;
}

.src-sidebar-search-AddressInput-module__input:focus {
    outline: none;
}

.src-sidebar-search-AddressInput-module__smallList {
    grid-column: 2 / 3;
    overflow-x: hidden;
}

@media (max-width: 44rem) {
    .src-sidebar-search-AddressInput-module__fullscreen {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        z-index: 5;
        padding: 0.5rem;
    }

    .src-sidebar-search-AddressInput-module__fullscreen .src-sidebar-search-AddressInput-module__inputContainer {
        grid-template-columns: auto 1fr auto;
    }

    .src-sidebar-search-AddressInput-module__fullscreen .src-sidebar-search-AddressInput-module__btnClose {
        display: block;
        margin: 0;
        padding: 5px 15px 5px 5px;
    }

    .src-sidebar-search-AddressInput-module__fullscreen .src-sidebar-search-AddressInput-module__btnInputClear {
        display: block;
    }
    /* when showing btnInputClear => remove the padding */
    .src-sidebar-search-AddressInput-module__fullscreen .src-sidebar-search-AddressInput-module__input {
        padding-right: 0;
    }
}

@media not all and (max-width: 44rem) {
    .src-sidebar-search-AddressInput-module__inputContainer:hover .src-sidebar-search-AddressInput-module__btnInputClear {
        display: block;
    }
    /* when showing btnInputClear => remove the padding */
    .src-sidebar-search-AddressInput-module__inputContainer:hover .src-sidebar-search-AddressInput-module__input {
        padding-right: 0;
    }
}

.src-sidebar-search-AddressInput-module__topBorder {
    padding-top: 3px;
    margin-top: -5px;
    border-top: dashed grey 2px;
}

.src-sidebar-search-AddressInput-module__bottomBorder {
    padding-bottom: 3px;
    margin-bottom: -5px;
    border-bottom: dashed grey 2px;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/search/AddressInput.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;;IAEX,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,oFAAoF;IACpF,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,MAAM;QACN,SAAS;QACT,OAAO;QACP,QAAQ;QACR,uBAAuB;QACvB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,cAAc;QACd,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;IACA,qDAAqD;IACrD;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA,qDAAqD;IACrD;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".btnInputClear {\n    display: none;\n    padding: 0 5px;\n    color: grey;\n    scale: 0.7;\n}\n\n.btnCurrentLocation {\n    padding: 0 7px 0 5px;\n    color: grey;\n    width: 32px;\n}\n\n.btnCurrentLocation > svg {\n    height: 100%;\n    width: 100%;\n}\n\n.btnClose {\n    display: none;\n}\n\n.inputContainer {\n    display: grid;\n    grid-template-columns: 1fr auto auto;\n    grid-gap: 0;\n\n    box-sizing: border-box;\n    border: 1px solid #5b616a;\n    border-radius: 0.2rem;\n    /* for the radius we need some padding otherwise the corners will be nearly hidden */\n    padding: 1px;\n}\n\n.input {\n    border: none;\n    padding: 0.25rem 0.5rem;\n    font-size: 1.05rem;\n}\n\n.input:focus {\n    outline: none;\n}\n\n.smallList {\n    grid-column: 2 / 3;\n    overflow-x: hidden;\n}\n\n@media (max-width: 44rem) {\n    .fullscreen {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background-color: white;\n        z-index: 5;\n        padding: 0.5rem;\n    }\n\n    .fullscreen .inputContainer {\n        grid-template-columns: auto 1fr auto;\n    }\n\n    .fullscreen .btnClose {\n        display: block;\n        margin: 0;\n        padding: 5px 15px 5px 5px;\n    }\n\n    .fullscreen .btnInputClear {\n        display: block;\n    }\n    /* when showing btnInputClear => remove the padding */\n    .fullscreen .input {\n        padding-right: 0;\n    }\n}\n\n@media not all and (max-width: 44rem) {\n    .inputContainer:hover .btnInputClear {\n        display: block;\n    }\n    /* when showing btnInputClear => remove the padding */\n    .inputContainer:hover .input {\n        padding-right: 0;\n    }\n}\n\n.topBorder {\n    padding-top: 3px;\n    margin-top: -5px;\n    border-top: dashed grey 2px;\n}\n\n.bottomBorder {\n    padding-bottom: 3px;\n    margin-bottom: -5px;\n    border-bottom: dashed grey 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnInputClear": `src-sidebar-search-AddressInput-module__btnInputClear`,
	"btnCurrentLocation": `src-sidebar-search-AddressInput-module__btnCurrentLocation`,
	"btnClose": `src-sidebar-search-AddressInput-module__btnClose`,
	"inputContainer": `src-sidebar-search-AddressInput-module__inputContainer`,
	"input": `src-sidebar-search-AddressInput-module__input`,
	"smallList": `src-sidebar-search-AddressInput-module__smallList`,
	"fullscreen": `src-sidebar-search-AddressInput-module__fullscreen`,
	"topBorder": `src-sidebar-search-AddressInput-module__topBorder`,
	"bottomBorder": `src-sidebar-search-AddressInput-module__bottomBorder`
};
export default ___CSS_LOADER_EXPORT___;
